/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ConnectAccountingProviderPayload = {
    providerType: ConnectAccountingProviderPayload.providerType;
    /**
     * API key for providers that use API key authentication
     */
    apiKey?: string;
};
export namespace ConnectAccountingProviderPayload {
    export enum providerType {
        LEXOFFICE = 'lexoffice',
        SEVDESK = 'sevdesk',
        TEBUTO = 'tebuto',
    }
}

